// extracted by mini-css-extract-plugin
export default {"container":"Checkboxes_container__PviVP"};